module.exports = __webpack_public_path__ + "da91ab311bb2f734eebba407724bb965.svg";